import { useFeatureFlag } from '@betterment/shared-components';

import { Nav } from '../../../Shared/components-v2/nav/Nav';
import { useProcessNavTransition } from '../../hooks/useProcessNavTransition';
import { NavLink } from '../nav-link/NavLink';

export const ActivityNav = () => {
  const processNavTransition = useProcessNavTransition();

  const { enabled: isActivityRefreshFeatureFlagEnabled } = useFeatureFlag({
    splitName: 'retail.activity_refresh_q1_2025_enabled',
    context: 'ActivityLinkSideBar',
  });

  const { enabled: isEnvelopesExperienceEnabled } = useFeatureFlag({
    splitName: 'retail.envelopes_experience_q1_2025_enabled',
    context: 'ActivityLinkSideBar',
  });

  return (
    <>
      <Nav.Separator />
      <Nav aria-label="Your Activity">
        <Nav.List>
          <Nav.ListItem key="performance">
            <NavLink to="/performance" onClick={processNavTransition}>
              <NavLink.Icon name="Bar" />
              <NavLink.Text>Performance</NavLink.Text>
            </NavLink>
          </Nav.ListItem>
          <Nav.ListItem key="activity">
            {isActivityRefreshFeatureFlagEnabled && isEnvelopesExperienceEnabled ? (
              <NavLink to="/activity" onClick={processNavTransition}>
                <NavLink.Icon name="List" />
                <NavLink.Text>Activity</NavLink.Text>
              </NavLink>
            ) : (
              <NavLink to="/activity_transactions" reloadDocument={true} onClick={processNavTransition}>
                <NavLink.Icon name="List" />
                <NavLink.Text>Activity</NavLink.Text>
              </NavLink>
            )}
          </Nav.ListItem>
          <Nav.ListItem key="transfers">
            <NavLink to="/transfers/new_transfer" onClick={processNavTransition}>
              <NavLink.Icon name="Transfer" />
              <NavLink.Text>Transfers</NavLink.Text>
            </NavLink>
          </Nav.ListItem>
          <Nav.ListItem key="documents">
            <NavLink to="/documents" onClick={processNavTransition}>
              <NavLink.Icon name="Document" />
              <NavLink.Text>Documents</NavLink.Text>
            </NavLink>
          </Nav.ListItem>
        </Nav.List>
      </Nav>
    </>
  );
};
